import React from 'react';
import { useLocation } from 'react-router';

import { FeatureFlag } from 'app/api/services/site-configs/types';

import { useFeatureFlag } from 'app/lib/feature-flags';
import { ROUTE_PATH } from 'app/lib/routing/constants';
import { TimeFilter } from 'app/modules/TimeFilter';
import ErrorBoundary from 'app/widgets/ErrorBoundary';

import { Container } from './components/Container/Container';
import { BettingTypeSwitcher } from './submodules/BettingTypeSwitcher';
import { LiveMenu } from './submodules/LiveMenu';
import { PrematchMenu } from './submodules/PrematchMenu';
import { PrematchMenuWS } from './submodules/PrematchMenuWS';

import styles from './BettingMenu.module.scss';

export const BettingMenu: React.FC = () => {
  const { pathname } = useLocation();
  const isPrematch = pathname.startsWith(ROUTE_PATH.PREMATCH);
  const isPrematchWS = useFeatureFlag(FeatureFlag.PREMATCH_WS);
  const hasTimeFilter = useFeatureFlag(FeatureFlag.TIME_FILTER);

  const getPrematchMenu = () => {
    if (isPrematchWS) {
      return <PrematchMenuWS />;
    }

    return <PrematchMenu />;
  };

  return (
    <Container>
      <ErrorBoundary>
        <BettingTypeSwitcher />
        {hasTimeFilter && isPrematch && <TimeFilter className={styles.timeFilter} />}
        {isPrematch ? getPrematchMenu() : <LiveMenu />}
      </ErrorBoundary>
    </Container>
  );
};
